// This module will require the index view and will render it in a root node
// It will probably be replaced by the index redux which will provide the state
import { createElement } from 'react';
import { render } from 'react-dom';

import IndexView from './index_view';

document.addEventListener('DOMContentLoaded', () => {
  // TODO: Probably it's a good idea to have an initApp method
  // That will do all we want to do before rendering the IndexView
  document.getElementById('no-javascript').remove();

  render(
    createElement(IndexView),
    document.getElementById('root'),
  );
});
